module.exports = __webpack_public_path__ + "assets/img/banner4.b9f7bf71.png";